import { useIncidentDetail } from 'core/components/JianDetail/hooks/useIncidentDetail';
import { enumTranslator } from './enumTranslator';

export type IncidentDetail = ReturnType<
  typeof useIncidentDetailForHiroshima
>['incidentDetailData']['incidentInfo'];
export type IncidentDetailEmsTeam = ReturnType<
  typeof useIncidentDetailForHiroshima
>['incidentDetailData']['emsTeamInfo'];
export type IncidentDetailPatients = ReturnType<
  typeof useIncidentDetailForHiroshima
>['incidentDetailData']['patientInfo'];
export type IncidentDetailPatient = ReturnType<
  typeof useIncidentDetailForHiroshima
>['incidentDetailData']['patientInfo'][number];
export type PatientTimeSeries = ReturnType<
  typeof useIncidentDetailForHiroshima
>['incidentDetailData']['patientInfo'][number]['timeSeries'];
export type ActivityRecordPdf = ReturnType<
  typeof useIncidentDetailForHiroshima
>['incidentDetailData']['patientInfo'][number]['activityRecordPdf'][number];

export const useIncidentDetailForHiroshima = () => {
  const { incidentDetailData, isLoading, isError } = useIncidentDetail();

  return {
    incidentDetailData: enumTranslator(incidentDetailData),
    isLoading,
    isError,
  };
};
